import { render, staticRenderFns } from "./FiguresList.vue?vue&type=template&id=ebbdd1b2&"
import script from "./FiguresList.vue?vue&type=script&lang=js&"
export * from "./FiguresList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports